import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import styles from "./styles/style.module.scss";
import { ReactComponent as AddIcon } from "./assets/add.svg";

const ControlArea = ({ btnTxt, cardTxt, icon, url }) => {
    useEffect(() => {
        const buttons = document.querySelectorAll('[data-animation="ripple"]');

        [...buttons].forEach((button) => {
            button.onmousedown = function (e) {
                const x = e.pageX - this.offsetLeft;
                const y = e.pageY - this.offsetTop;
                const w = this.offsetWidth;

                const ripple = document.createElement("span");

                ripple.className = "ripple";
                ripple.style.left = x + "px";
                ripple.style.top = y + "px";
                ripple.style.setProperty("--scale", w);

                this.appendChild(ripple);

                // setTimeout(() => {
                //   ripple.parentNode.removeChild(ripple);
                // }, 500);
            };
        });
    }, []);

    // Danger Modal

    return (
        <>
            <div className={styles["control-wrapper"]}>
                <Row className="gy-3">
                    {!!btnTxt && (
                        <Col xl={4} md={4} sm={12}>
                            <NavLink
                                to={url}
                                className="button-link btn btn-big"
                                data-animation="ripple"
                            >
                                <AddIcon />
                                {btnTxt}
                            </NavLink>
                        </Col>
                    )}
                    <Col>
                        <div className="control-wrapper-header">
                            <h5>
                                <img src={icon} width={20} height={20} alt="" />
                                {cardTxt}
                            </h5>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default ControlArea;
